import React, { Fragment } from "react";
import { SpeedDial } from "primereact/speeddial";
import CenterElement from "./CenterElement";
import helpIcon from "../../../../res/imgs/help.png";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  withRouter,
} from "react-router-dom";

class AppFooter extends React.Component {
  state = {
    confirmBtnTitle: "تأكيد",
  };

  render = () => {
    let { quizViwerModel, activity } = this.props;

    return (
      <>
        <div
          style={{
            position: "fixed",
            bottom: "0px",
            top: "90%",
            width: "100%",
            height: "200px",
          }}
        >
          <div className="grid justify-content-between">
            {/* {quizViwerModel.callbackData.isExam != "true" ? (
            //   <div
            //     className="col-1 col-align-left"
            //     style={{ textAlign: "left" }}
            //   >
            //     <img src={helpIcon} style={{ width: "35px" }} />
            //   </div>
            // ) : (
            //   ""
            // )} */}
          </div>
          {this.getControlBtn()}
        </div>
      </>
    );
  };

  getControlBtn = () => {
    let { quizViwerModel, activity } = this.props;

    if (
      quizViwerModel.callbackData.isExam &&
      quizViwerModel.callbackData.isExam == "true"
    ) {
      return (
        <Fragment>
          <div
            className="flex justify-content-between  footer"
            style={{ paddingRight: "10px", paddingLeft: "10px" }}
          >
            {/* <div className="col-2"></div> */}
            <div
              className="col-3"
              style={{ textAlign: "right", padding: "5px 0" }}
            >
              <div
                onClick={this.handleNextForExam}
                style={{ backgroundColor: "#7E57C2", color: "#fff" }}
                className="btn-shape btn btn-md btn-block btnColor footer-btn  footer-left-btn"
              >
                <CenterElement
                  content="التالي"
                  textAlign="center"
                  style={{ fontSize: "16px", fontFamily: "sstArabic" }}
                />
              </div>
            </div>
            {/* <div className="col-2"></div> */}

            <div
              className="col-3"
              style={{ textAlign: "left", padding: "5px 0" }}
            >
              <div
                onClick={() => this.handlePrevForExam(activity)}
                style={{
                  backgroundColor: "gray",
                  color: "#fff",
                  border: "none",
                }}
                className="btn-shape btn btn-danger btn-sm btn-block btnColor footer-btn footer-right-btn"
                disabled={activity.activityIndex == 0}
              >
                <CenterElement
                  content="السابق"
                  textAlign="center"
                  style={{ fontSize: "16px", fontFamily: "sstArabic" }}
                />
              </div>
            </div>
            {/* <div className="col-2"></div> */}
          </div>
        </Fragment>
      );
    } else {
      return (
        <div className="flex  footer">
          {/* <div className="col-2"></div> */}
          <div
            className="col-2"
            style={{
              textAlign: "right",
            }}
          >
            <div
              onClick={() => this.handleSkipActivity(activity)}
              className="footer-btn footer-left-btn"
            >
              <CenterElement
                content="تخطي"
                textAlign="center"
                style={{ fontSize: "16px", fontFamily: "sstArabic" }}
              />
            </div>
          </div>
          {/* <div className="col-2"></div> */}

          <div className="col-2 " style={{ textAlign: "left" }}>
            <div
              onClick={() => this.handleShowResultPage(activity)}
              className="footer-btn footer-right-btn"
            >
              <CenterElement
                content={this.state.confirmBtnTitle}
                textAlign="center"
                style={{ fontSize: "16px", fontFamily: "sstArabic" }}
              />
            </div>
          </div>
          {/* <div className="col-2"></div> */}
        </div>
      );
    }
  };

  handleNextForExam = () => {
    this.handleNextActivity();
  };

  saveReportCallback = (res) => {
    let { app, quizViewer } = this.props;

    let { quizViwerModel } = quizViewer.state;
    if (quizViwerModel.showResultPage) {
      // this.props.history.push("/result_page/true");
      this.props.history.push("/result_page_mobile/true");
    }
  };

  handleNextActivity = () => {
    let { quizViwerModel, activity, quizViewer } = this.props;
    quizViwerModel.reviewMode = false;
    quizViwerModel.activityArr[
      quizViwerModel.currentActivity
    ].getAnsweredTrue();
    quizViewer.stopCurrentSound();
    quizViwerModel.gotoNext(this.saveReportCallback);

    if (!quizViwerModel.showResultPage) quizViewer.setState({ quizViwerModel });
  };

  handlePrevForExam = () => {
    let { quizViwerModel, activity, quizViewer } = this.props;
    quizViwerModel.reviewMode = false;
    quizViwerModel.activityArr[
      quizViwerModel.currentActivity
    ].getAnsweredTrue();
    quizViewer.stopCurrentSound();
    quizViwerModel.gotoPrev();

    if (!quizViwerModel.showResultPage) quizViewer.setState({ quizViwerModel });
  };

  toArabicDigits = (num) => {
    var id = ["۰", "۱", "۲", "۳", "٤", "٥", "٦", "۷", "۸", "۹"];
    return num.toString().replace(/[0-9]/g, function (w) {
      return id[+w];
    });
  };

  handleShowResultPage = (activity) => {
    let { app, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;

    if (quizViwerModel.reviewMode) {
      quizViwerModel.reviewMode = false;
      this.handleNextActivity();
      this.setState({ confirmBtnTitle: "تأكيد" });
    } else {
      activity.getAnsweredTrue();
      quizViwerModel.reviewMode = true;
      this.setState({ confirmBtnTitle: "التالي" });
    }
    quizViewer.setState({ quizViwerModel });
  };

  handleSkipActivity = (activity) => {
    activity.isSkipped = true;
    this.handleNextActivity();
    this.setState({ confirmBtnTitle: "تأكيد" });
  };
}

export default withRouter(AppFooter);
